import { Accessor, Setter, createContext, createSignal, useContext } from "solid-js";
import { STGridEvents } from "../st-grid/STGridEvents";
import { ViewState } from "../../api";
import { requireContext } from "common";

export class FindResultPanelContext {
    searchCriteria: Accessor<SearchCriteria>;
    setSearchCriteria: Setter<SearchCriteria>;

    selectedRows: Accessor<string[]>;
    setSelectedRows: Setter<string[]>;

    viewState: Accessor<ViewState>
    setViewState: Setter<ViewState>

    events: STGridEvents = new STGridEvents();

    constructor() {
        [this.searchCriteria, this.setSearchCriteria] = createSignal(new SearchCriteria());
        [this.selectedRows, this.setSelectedRows] = createSignal<string[]>([]);
        [this.viewState, this.setViewState] = createSignal(new ViewState());
    }
}
export const FindResultPanelContextJsx = createContext<FindResultPanelContext>();
export function useFindResultPanelContext() {
    return useContext(FindResultPanelContextJsx);
}
export function requireFindResultPanelContext() {
    return requireContext(FindResultPanelContextJsx);
}

export class SearchCriteria {
    controls: Record<string, SearchCriteriaElement> = {};
    grids: Record<string, SearchCriteriaGridElement> = {};
}

export class SearchCondition {
    type: string = 'AND';
    values: Array<string> = [];
}

export class SearchCriteriaGridElement {
    guid: string = '';
    label: string = '';
    columns: Record<string, SearchCriteriaElement> = {};
}

export class SearchCriteriaElement {
    label: string = '';
    srcName: string = '';
    value: string = '';
    desc: string = '';
    fkSource: string = '';
    isData: boolean = false;
    condition: SearchCondition | undefined;
}
